import {Pipe, PipeTransform} from '@angular/core';
import {LoggedUser} from '../common/logged-user.service';

@Pipe({
  name: 'tenantsResolver'
})
export class TenantsResolverPipe implements PipeTransform {

  constructor(private loggedUser: LoggedUser) {
  }

  transform(value: string): string {
    if (value === undefined) {
      return '';
    }
    const tenant: any = this.loggedUser.userTenants.find(entry => entry.machineUuid === value);
    return tenant === undefined ? value : tenant.name;
  }

}
